import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './PaymentEditScreen';
import PaymentEdit from './PaymentEditScreen';
import { StoreState } from 'src/store/reducers';
import { getPayment } from 'src/store/actions/payment-actions';
import { change, getFormValues } from 'redux-form';
import { QueryParams } from '../../../../../../types/grid';
import { getStudentsSmall } from '../../../../../../store/actions/student-actions';
import { getDistrictsSmall } from '../../../../../../store/actions/district-actions';
import { getVendorsSmall } from '../../../../../../store/actions/vendor-actions';
import { getInvoices, getInvoicesSmall } from '../../../../../../store/actions/invoice-actions';
import { getServiceTypes } from '../../../../../../store/actions/service-type-actions';
import { caseNumbers } from '../../../../../../store/actions/case-actions';
import { selectNameStudents } from '../../../../../../store/selectors/students-selectors';
import { selectNameDistricts } from '../../../../../../store/selectors/districts-selectors';
import { selectNameVendors } from '../../../../../../store/selectors/vendors-selectors';
import { getProvidersSmall } from '../../../../../../store/actions/provider-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        payment: state.payments.current,

        students: selectNameStudents(state),
        districts: selectNameDistricts(state),
        vendors: selectNameVendors(state),
        providers: selectNameProviders(state),
        invoices: state.invoices.data,
        inProgress: state.invoices.inProgress,

        serviceTypes: state.serviceTypes.data,
        caseNumbers: state.cases.caseNumbers,
        valuesForm: getFormValues('payment-form')(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getPayment(id)),
        changeValue: (field: string, value: string | null) => {
            dispatch(change('payment-form', field, value));
        },
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        getCaseNumbers: () => dispatch(caseNumbers()),
        getDistricts: (params: QueryParams) => dispatch(getDistrictsSmall(params)),
        getVendors: (params: QueryParams) => dispatch(getVendorsSmall(params)),
        getInvoices: (params: QueryParams) => dispatch(getInvoicesSmall({ ...params, notTotal: true })),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}

const PaymentEditScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(PaymentEdit);

export default PaymentEditScreen;
